import React, { useState } from 'react'; // 1. Added useState
import './Navbar.css';
import logo from './logo1.png';

const Navbar = ({ onNavigate, activePage }) => {
  const [isOpen, setIsOpen] = useState(false); // 2. State for mobile menu

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  return (
    <nav className="std-navbar">
      <div className="navbar-container">
        <div className="left-section">
          <a href="/" className="nav-logo" onClick={handleLogoClick}>
            <img src={logo} alt="PhysioVeda Logo" />
          </a>

          {/* 3. Added dynamic class 'mobile-open' based on state */}
          <div className={`nav-links ${isOpen ? 'mobile-open' : ''}`}>
            <a
              href="#home"
              className={activePage === 'home' ? 'active' : ''}
              onClick={(e) => { e.preventDefault(); onNavigate('home'); closeMenu(); }}
            >
              Home
            </a>
            <a
              href="#about"
              className={activePage === 'about' ? 'active' : ''}
              onClick={(e) => { e.preventDefault(); onNavigate('about'); closeMenu(); }}
            >
              About
            </a>
            <a
              href="#doctors"
              className={activePage === 'doctors' ? 'active' : ''}
              onClick={(e) => { e.preventDefault(); onNavigate('doctors'); closeMenu(); }}
            >
              Our Doctors
            </a>

            <a
              href="#technology"
              className={activePage === 'technology' ? 'active' : ''}
              onClick={(e) => { e.preventDefault(); onNavigate('technology'); closeMenu(); }}
            >
              Technology
            </a>

            <div className="nav-item-dropdown">
              <span className={`dropdown-trigger ${activePage === 'robotic-spinal' || activePage === 'Emteslla' ? 'active' : ''}`}>
                Advance Technologies <i className="arrow-down"></i>
              </span>
              <div className="dropdown-menu">
                <a
                  href="#robotic-spinal"
                  className={activePage === 'robotic-spinal' ? 'active' : ''}
                  onClick={(e) => { e.preventDefault(); onNavigate('robotic-spinal'); closeMenu(); }}
                >
                  Robotic Spinal Decompression
                </a>
                <a
                  href="#emteslla"
                  className={activePage === 'Emteslla' ? 'active' : ''}
                  onClick={(e) => { e.preventDefault(); onNavigate('Emteslla'); closeMenu(); }}
                >
                  EMTESLLA
                </a>
              </div>
            </div>



            {/* Mobile-only contact link inside the menu */}
            <a
              href="#contact"
              className={`mobile-only-contact ${activePage === 'contact' ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); onNavigate('contact'); closeMenu(); }}
            >
              Contact Us
            </a>
          </div>
        </div>

        <div className="right-section">
          <button
            className={`nav-btn-book ${activePage === 'contact' ? 'active' : ''}`}
            onClick={() => onNavigate('contact')}
          >
            Contact Us
          </button>

          {/* 4. Hamburger Button */}
          <div className={`hamburger ${isOpen ? 'is-active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;